export default {
  name: 'ScDataListIterator',
  props: {
    contentTitle: {
      type: String,
      default: '',
    },
    contentSubtitle: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => ([]),
    },
  },
  methods: {
    shouldItemDisplay(item) {
      if ({}.hasOwnProperty.call(item, 'shouldDisplay')) {
        return item.shouldDisplay;
      }
      return true;
    },
    negativeValue(item) {
      if ({}.hasOwnProperty.call(item, 'isNegative') && item.isNegative) {
        return true;
      }
      return false;
    },
  },
};
